import { render } from "./DisciplineDeleteModal.vue?vue&type=template&id=ae71bd78"
import script from "./DisciplineDeleteModal.vue?vue&type=script&lang=js"
export * from "./DisciplineDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bilimcert/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__